import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { Link, useParams } from 'react-router-dom';

const OrderNotFound = () => {
  const [translate] = useTranslation();
  const { slug } = useParams();

  return (
    <Container className="text-center">
      <Row>
        <Col xs={12} className="py-5 text-primary">
          <FontAwesomeIcon icon={faQuestionCircle} size="6x" />
        </Col>
        <Col xs={12} className="py-2">
          <h1 className="text-primary fw-bold">
            {translate('COMMON.NO_ORDER')}
          </h1>
        </Col>
        <Col xs={12}>
          <Link to={`/${slug}`}>
            {translate('COMMON.BACK_TO_SHOP')}
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default OrderNotFound;
